<template>
  <v-container class="mx-auto pa-sm-3 pa-0" style="max-width:1280px">
    <v-toolbar>
      <v-toolbar-title>Legal & Privacy</v-toolbar-title>
    </v-toolbar>
    <v-col cols="12"></v-col>
    <v-col cols="12">
      <v-btn text large color="primary" href="/doc/Terms _ Conditions/93cd00ea-dc93-4bae-8960-863010c65b39_en.docx"><v-icon left>mdi-file-document</v-icon>Terms & Conditions</v-btn>
    </v-col>
    <v-col cols="12">
      <v-btn text large color="primary" href="/doc/Privacy Policy/fe53405e-2417-46ae-a0ac-146f40b8b38b_en.docx"><v-icon left>mdi-file-document</v-icon>Privacy Policy</v-btn>
    </v-col>
    <v-col cols="12">
      <v-btn text large color="primary"><v-icon left>mdi-file-document</v-icon>EULA</v-btn>
    </v-col>
    <v-col cols="12">
      <v-btn text large color="primary" href="/doc/Disclaimer/Disclaimer.docx"><v-icon left>mdi-file-document</v-icon>Disclaimer</v-btn>
    </v-col>
    <v-footer
      fixed
      class="pa-0"
    >
      <v-btn
        block
        tile
        large
        dark
        color="green"
        @click="$router.push('search')"
      >
        Close
      </v-btn>
    </v-footer>
  </v-container>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
    }
  },

  methods: {
  }
}
</script>
